import { render, staticRenderFns } from "./ProjectDocSelectorModal.vue?vue&type=template&id=6a5f0dfa&scoped=true&"
import script from "./ProjectDocSelectorModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDocSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDocSelectorModal.vue?vue&type=style&index=0&id=6a5f0dfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f0dfa",
  null
  
)

export default component.exports